import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface MicInfoState {
  userMic: boolean;
}

const LOCALKEY = localKeyInfo.micInfo;
const localVoiceInfo = LocalStore.getValue<MicInfoState>(LOCALKEY) || {};

export const micInfo: MicInfoState = {
  userMic: false,
  ...localVoiceInfo
};

export const setMicInfo: (payload: MicInfoState) => IAction<MicInfoState> = (payload: MicInfoState) => ({
  type: 'setMicInfo',
  payload
});

const micInfoReducer: Reducer<MicInfoState, IAction<any>> = (state = micInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setMicInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default micInfoReducer;
